// import CountUp from "react-countup";
// import { useInView } from "react-intersection-observer";
// import PageLayout from "../PageLayout";

// function Aboutus() {

//   const { ref, inView } = useInView({
//     triggerOnce: true,
//     threshold: 0.5,
//   });

//   const data = {
//     number: "01",
//     name: "Stats & facts",
//     heading: "High quality web design solutions you can trust.",
//     description:
//       "When selecting a web design agency, it's essential to consider its reputation, experience, and the specific needs of your project.",
//     scoreData: [
//       {
//         number: 95,
//         numberValue: "%",
//         scoreDescp:
//           "de nos clients recommanderaient nos services à leurs proches.",
//       },
//       {
//         number: 90,
//         numberValue: "%",
//         scoreDescp: "des demandes sont traitées en moins de 2 heures.",
//       },
//       {
//         number: 500,
//         numberValue: "+",
//         scoreDescp: "événements organisés avec succès depuis notre création.",
//       },
//     ],
//   };

//   return (
//     <>
//       <PageLayout>
//         <content>
//         <section className="relative bg-white overflow-hidden">
//             <div className="flex py-20 md:py-40 z-10">
//               <div className="container">
//                 <div className="flex flex-col xl:flex xl:flex-row justify-center items-center gap-8">
//                   <div className="flex flex-col justify-center items-center gap-11">
//                     <div className="flex flex-col justify-center items-center gap-5">
//                       <h2>Bienvenue chez Les Clés Conciergerie</h2>
//                       <p className="flex justify-center items-center text-[22px] max-w-3xl text-secondary/70">
//                         Votre partenaire pour des solutions sur mesure. Que vous ayez
//                         besoin d’organiser un voyage inoubliable, de gérer une
//                         propriété ou de simplifier vos tâches quotidiennes, notre
//                         équipe est à votre service 24/7 pour répondre à vos besoins
//                         avec élégance et efficacité.
//                       </p>
//                     </div>
//                     <div className="grid items-center md:grid-cols-3 max-w-3xl gap-8">
//                       {data?.scoreData?.map((value, index) => {
//                         return (
//                           <div
//                             ref={ref}
//                             key={index}
//                             className="flex flex-col gap-5 pt-4 border-t border-secondary/12"
//                           >
//                             <h3 className="text-5xl md:text-6xl Xxl:text-7xl font-bold">
//                               {inView ? (
//                                 <CountUp start={0} end={value.number} duration={3} />
//                               ) : (
//                                 "0"
//                               )}
//                               {value.numberValue && <span>{value.numberValue}</span>}
//                             </h3>
//                             <p className="text-secondary/70 text-[15px]">
//                               {value.scoreDescp}
//                             </p>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </section>
//         </content>
//       </PageLayout>
//     </>
//   );
// }

// export default Aboutus;

import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import PageLayout from "../PageLayout";

function Aboutus() {
  // const [data, setData] = useState(null);
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const data = {
    number: "01",
    name: "Stats & facts",
    heading: "High quality web design solutions you can trust.",
    description:
      "When selecting a web design agency, it's essential to consider its reputation, experience, and the specific needs of your project.",
    scoreData: [
      {
        number: 95,
        numberValue: "%",
        scoreDescp:
          "de nos clients recommanderaient nos services à leurs proches.",
      },
      {
        number: 90,
        numberValue: "%",
        scoreDescp: "des demandes sont traitées en moins de 2 heures.",
      },
      {
        number: 500,
        numberValue: "+",
        scoreDescp: "événements organisés avec succès depuis notre création.",
      },
    ],
  };

  // useEffect(() => {
  //   setData(statsFactData);
  // }, []);

  return (
    <>
      <PageLayout>
        <content>
          <section className="relative bg-lightgray overflow-hidden">
            <div className="flex py-20 md:py-40 z-10">
              <div className="container">
                <div className="flex flex-col xl:flex xl:flex-row justify-center items-center gap-8">
                  <div className="flex flex-col justify-center items-center gap-11">
                    <div className="flex flex-col justify-center items-center gap-5">
                      <p className="sm:text-[35px]">
                        Bienvenue chez Les Clés Conciergerie
                      </p>
                      <p className="flex justify-center items-center text-[12px] sm:text-[22px] max-w-3xl text-secondary/70">
                        Votre partenaire pour des solutions sur mesure. Que vous
                        ayez besoin d’organiser un voyage inoubliable, de gérer
                        une propriété ou de simplifier vos tâches quotidiennes,
                        notre équipe est à votre service 24/7 pour répondre à
                        vos besoins avec élégance et efficacité.
                      </p>
                    </div>
                    <div className="grid items-center grid-cols-3 max-w-3xl gap-8">
                      {data?.scoreData?.map((value, index) => {
                        return (
                          <div
                            ref={ref}
                            key={index}
                            className="flex flex-col gap-5 pt-4 border-t border-secondary/12"
                          >
                            <h3 className="text-2xl md:text-6xl Xxl:text-7xl font-bold">
                              {inView ? (
                                <CountUp
                                  start={0}
                                  end={value.number}
                                  duration={3}
                                />
                              ) : (
                                "0"
                              )}
                              {value.numberValue && (
                                <span>{value.numberValue}</span>
                              )}
                            </h3>
                            <p className="text-secondary/70 text-[12px] sm:text-[15px]">
                              {value.scoreDescp}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                    <div className="mt-9">
                      <style>{`
                  .neumorphic-liquid {
                    position: relative;
                    display: inline-block;
                    overflow: hidden;
                    padding: 0.7em 1.7em;
                    font-size: 10px;
                    font-weight: 400;
                    color: #090909;
                    background: white;
                    border: 1px solid black;
                    border-radius: 0.5em;
                    cursor: pointer;
                    transition: all 0.2s ease-in;
                    z-index: 1;
                    text-transform: uppercase;
                    font-family: Jost;
                  }

                  .neumorphic-liquid::before {
                    content: "";
                    position: absolute;
                    left: 50%;
                    top: 100%;
                    width: 140%;
                    height: 180%;
                    background-color: rgba(0, 0, 0, 0.05);
                    border-radius: 50%;
                    transform: translateX(-50%) scaleY(1) scaleX(1.25);
                    transition: all 0.5s 0.1s cubic-bezier(0.55, 0, 0.1, 1);
                    z-index: -1;
                  }

                  .neumorphic-liquid::after {
                    content: "";
                    position: absolute;
                    left: 55%;
                    top: 180%;
                    width: 160%;
                    height: 190%;
                    background-color: #ad3500;
                    border-radius: 50%;
                    transform: translateX(-50%) scaleY(1) scaleX(1.45);
                    transition: all 0.5s 0.1s cubic-bezier(0.55, 0, 0.1, 1);
                    z-index: -1;
                  }

                  .neumorphic-liquid:hover {
                    color: #ffffff;
                    border: 1px solid #ad3500;
                  }

                  .neumorphic-liquid:hover::before {
                    top: -35%;
                    background-color: #ad3500;
                    transform: translateX(-50%) scaleY(1.3) scaleX(0.8);
                  }

                  .neumorphic-liquid:hover::after {
                    top: -45%;
                    background-color: #ad3500;
                    transform: translateX(-50%) scaleY(1.3) scaleX(0.8);
                  }

                  .neumorphic-liquid:active {
                    color: #666;
                    box-shadow: inset 4px 4px 12px #c5c5c5,
                      inset -4px -4px 12px #ffffff;
                  }
                `}</style>
                      <a
                        href="/about"
                        className="neumorphic-liquid tracking-[2px]"
                      >
                        <span className="text-[10px] sm:text-[15px]">
                          Découvrir qui nous sommes
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </content>
      </PageLayout>
    </>
  );
}

export default Aboutus;
